import DuckEntity from './DuckEntity'

const entity = new DuckEntity('statuses');
const reducer = entity.reducer;
export {reducer as default, entity};
